var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "nltha",
    d: "M542.48 6264c8.2 0 14.83 6.72 14.83 15 0 8.28-6.64 15-14.83 15a14.92 14.92 0 0 1-14.82-15c0-8.28 6.64-15 14.82-15z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-527 -6264)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#f26552",
    xlinkHref: "#nltha"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-527 -6264)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(540 6276)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAAZElEQVQYV23OMQrCUBRE0fP2KIidBNyDhaBg4VLsbLSwEPejSwiEkR8SSGE7M5c7leSDJ7qqGqCSXLDHDZuq6qs1Sc444IH1GE5FWzfq/S98zfgRJ9yxWoqu2I6iJN9JsJsv/QCetyuFpXt2QwAAAABJRU5ErkJggg=="
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrRight);
export default __webpack_public_path__ + "static/media/arr-right.152c3cf0cddb4c3746d6e274b699ebcd.svg";
export { ForwardRef as ReactComponent };